export interface AttendanceFilters {
  event: string;
  user: string;
  attendee_type: string;
  event_date: string;
  time_in: string;
  time_out: string;
  status: string;
  rewarded_points: number | null;
}

export const defaultAttendanceFilters: AttendanceFilters = {
  event: "",
  user: "",
  attendee_type: "",
  event_date: "",
  time_in: "",
  time_out: "",
  status: "",
  rewarded_points: null,
};

export interface AttendanceItem {
  event_image_url: string;
  event_name: string;
  event_description: string;
  event_location: string;
  event_latitude: string;
  event_longitude: string;
  event_date: string;
  event_start_time: string;
  event_end_time: string;
  user: {
    first_name: string;
    last_name: string;
    email: string;
  };
  user_time_in: string;
  user_time_out: string;
  attendance_status: string;
  point_reward: number;
  user_type: string;
}

export interface AttendanceListRequest {
  pagination: { index: number; size: number };
  filter?: Record<string, unknown>;
  sorting?: Record<string, "ASC" | "DESC">;
}

export interface AttendanceListResponse {
  paging: { count: number; index: number; size: number };
  list: AttendanceItem[];
}

export interface AttendanceStatistics {
  monthly_attendance_rate?: AttendanceRate;
  weekly_attendance_rate?: AttendanceRate;
}

export interface AttendanceRate {
  current_rate: number;
  previous_rate: number;
  change_percentage: number;
  trend: "up" | "down" | "stable";
}
